import { render } from "./FileUploader.vue?vue&type=template&id=81fd65d0&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=81fd65d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-81fd65d0"

export default script